/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  WordView,
  PlatzApiError,
  Word,
  CreateWordEventRequest,
  SnippetsForSourceView,
} from ".././model";
import { customInstance } from "../../../axios";
import type { ErrorType, BodyType } from "../../../axios";

export const setAsUnopened = (id: number) => {
  return customInstance<WordView>({
    url: `/api/words/${id}/unopened`,
    method: "put",
  });
};

export type SetAsUnopenedMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAsUnopened>>
>;

export type SetAsUnopenedMutationError = ErrorType<PlatzApiError>;

export const useSetAsUnopened = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAsUnopened>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAsUnopened>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return setAsUnopened(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof setAsUnopened>>,
    TError,
    { id: number },
    TContext
  >(mutationFn, mutationOptions);
};
export const setAsLearning = (id: number) => {
  return customInstance<WordView>({
    url: `/api/words/${id}/learning`,
    method: "put",
  });
};

export type SetAsLearningMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAsLearning>>
>;

export type SetAsLearningMutationError = ErrorType<PlatzApiError>;

export const useSetAsLearning = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAsLearning>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAsLearning>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return setAsLearning(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof setAsLearning>>,
    TError,
    { id: number },
    TContext
  >(mutationFn, mutationOptions);
};
export const setAsIgnored = (id: number) => {
  return customInstance<WordView>({
    url: `/api/words/${id}/ignore`,
    method: "put",
  });
};

export type SetAsIgnoredMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAsIgnored>>
>;

export type SetAsIgnoredMutationError = ErrorType<PlatzApiError>;

export const useSetAsIgnored = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAsIgnored>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAsIgnored>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return setAsIgnored(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof setAsIgnored>>,
    TError,
    { id: number },
    TContext
  >(mutationFn, mutationOptions);
};
export const setAsGotIt = (id: number) => {
  return customInstance<WordView>({
    url: `/api/words/${id}/gotit`,
    method: "put",
  });
};

export type SetAsGotItMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAsGotIt>>
>;

export type SetAsGotItMutationError = ErrorType<PlatzApiError>;

export const useSetAsGotIt = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAsGotIt>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAsGotIt>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return setAsGotIt(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof setAsGotIt>>,
    TError,
    { id: number },
    TContext
  >(mutationFn, mutationOptions);
};
export const setMultipleAsIgnored = (setMultipleAsIgnoredBody: number[]) => {
  return customInstance<WordView[]>({
    url: `/api/words/set-words-as-ignore`,
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: setMultipleAsIgnoredBody,
  });
};

export type SetMultipleAsIgnoredMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMultipleAsIgnored>>
>;
export type SetMultipleAsIgnoredMutationBody = BodyType<number[]>;
export type SetMultipleAsIgnoredMutationError = ErrorType<PlatzApiError>;

export const useSetMultipleAsIgnored = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMultipleAsIgnored>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMultipleAsIgnored>>,
    { data: BodyType<number[]> }
  > = (props) => {
    const { data } = props ?? {};

    return setMultipleAsIgnored(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof setMultipleAsIgnored>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >(mutationFn, mutationOptions);
};
export const setMultipleAsGotIt = (setMultipleAsGotItBody: number[]) => {
  return customInstance<WordView[]>({
    url: `/api/words/set-words-as-gotit`,
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: setMultipleAsGotItBody,
  });
};

export type SetMultipleAsGotItMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMultipleAsGotIt>>
>;
export type SetMultipleAsGotItMutationBody = BodyType<number[]>;
export type SetMultipleAsGotItMutationError = ErrorType<PlatzApiError>;

export const useSetMultipleAsGotIt = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMultipleAsGotIt>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMultipleAsGotIt>>,
    { data: BodyType<number[]> }
  > = (props) => {
    const { data } = props ?? {};

    return setMultipleAsGotIt(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof setMultipleAsGotIt>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >(mutationFn, mutationOptions);
};
export const getAllWords = (signal?: AbortSignal) => {
  return customInstance<Word[]>({ url: `/api/words`, method: "get", signal });
};

export const getGetAllWordsQueryKey = () => [`/api/words`];

export type GetAllWordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllWords>>
>;
export type GetAllWordsQueryError = ErrorType<PlatzApiError>;

export const useGetAllWords = <
  TData = Awaited<ReturnType<typeof getAllWords>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAllWords>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllWordsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllWords>>> = ({
    signal,
  }) => getAllWords(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getAllWords>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const createWord = (word: BodyType<Word>) => {
  return customInstance<Word>({
    url: `/api/words`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: word,
  });
};

export type CreateWordMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWord>>
>;
export type CreateWordMutationBody = BodyType<Word>;
export type CreateWordMutationError = ErrorType<PlatzApiError>;

export const useCreateWord = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWord>>,
    TError,
    { data: BodyType<Word> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWord>>,
    { data: BodyType<Word> }
  > = (props) => {
    const { data } = props ?? {};

    return createWord(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof createWord>>,
    TError,
    { data: BodyType<Word> },
    TContext
  >(mutationFn, mutationOptions);
};
export const createWordEvent = (
  createWordEventRequest: BodyType<CreateWordEventRequest>
) => {
  return customInstance<void>({
    url: `/api/words/word-event`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: createWordEventRequest,
  });
};

export type CreateWordEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWordEvent>>
>;
export type CreateWordEventMutationBody = BodyType<CreateWordEventRequest>;
export type CreateWordEventMutationError = ErrorType<PlatzApiError>;

export const useCreateWordEvent = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWordEvent>>,
    TError,
    { data: BodyType<CreateWordEventRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWordEvent>>,
    { data: BodyType<CreateWordEventRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createWordEvent(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof createWordEvent>>,
    TError,
    { data: BodyType<CreateWordEventRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const getInterestingWords = (signal?: AbortSignal) => {
  return customInstance<SnippetsForSourceView[]>({
    url: `/api/words/interesting`,
    method: "get",
    signal,
  });
};

export const getGetInterestingWordsQueryKey = () => [`/api/words/interesting`];

export type GetInterestingWordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInterestingWords>>
>;
export type GetInterestingWordsQueryError = ErrorType<PlatzApiError>;

export const useGetInterestingWords = <
  TData = Awaited<ReturnType<typeof getInterestingWords>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getInterestingWords>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInterestingWordsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInterestingWords>>
  > = ({ signal }) => getInterestingWords(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getInterestingWords>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};
